import React, {Component} from 'react';
import styles from './HowItWorksSection.scss';
import classNames from 'classnames/bind';
import {observable, action} from 'mobx';
import {observer} from 'mobx-react';
import TimelineMax from 'TimelineMax';
import ScrollMagic from 'ScrollMagic';
import {Linear} from 'gsap';
import 'animation.gsap';
import Swiper from 'swiper/dist/js/swiper.js'
import $ from 'jquery';
import {HowItWorksSceneBackdrop, HowItWorksSceneForeground, ParticleCanvas} from '../../organisms';

const cx = classNames.bind(styles);

class HowItWorksSectionStore {
  @observable particleCount;

  @action setParticleCount = (paramParticleCount) => this.particleCount = paramParticleCount;
}

const howItWorksSectionStore = new HowItWorksSectionStore();

@observer
class HowItWorksSection extends Component {
  factorsSwiper;
  howItWorksSectionRef;

  handleResize = () => {
    const particleCount = this.getParticleCount();
    (particleCount !== howItWorksSectionStore.particleCount)
      && howItWorksSectionStore.setParticleCount(particleCount);
  };

  getParticleCount = () => {
    return window.innerWidth > 768 ? 250 : 0;
  };

  handleSceneAnimation = () => {
    const {howItWorksSectionRef} = this;

    const howItWorksController = new ScrollMagic.Controller();

    const bubbleTempTween = new TimelineMax();
    const bubbleHumidityTween = new TimelineMax();
    const bubbleCO2Tween = new TimelineMax();
    const bubbleChemicalsTween = new TimelineMax();
    const bubbleDustTween = new TimelineMax();

    bubbleTempTween.to('#bubble-temp', 10, {
      bezier: [{x: 0, y: 0}, {x: 12, y: -6}, {x: 8, y: 4}, {x: 0, y: 0}, {x: -9, y: -7}, {x: -14, y: 7}, {x: 0, y: 0}],
      ease: Linear.easeNone,
      repeat: -1
    });

    bubbleHumidityTween.to('#bubble-humidity', 10, {
      bezier: [{x: 0, y: 0}, {x: -9, y: 7}, {x: -13, y: -5}, {x: 0, y: 0},{x: 12, y: 9}, {x: 8, y: -7}, {x: 0, y: 0}],
      ease: Linear.easeNone,
      repeat: -1
    });

    bubbleCO2Tween.to('#bubble-co2', 10, {
      bezier: [{x: 0, y: 0}, {x: -12, y: 5}, {x: -8, y: -7}, {x: 0, y: 0}, {x: 16, y: 4}, {x: 3, y: -10}, {x: 0, y: 0}],
      ease: Linear.easeNone,
      repeat: -1
    });

    bubbleChemicalsTween.to('#bubble-chemicals', 10, {
      bezier: [{x: 0, y: 0}, {x: 12, y: -6}, {x: 8, y: 4}, {x: 0, y: 0}, {x: -9, y: -7}, {x: -14, y: 7}, {x: 0, y: 0}],
      ease: Linear.easeNone,
      repeat: -1
    });

    bubbleDustTween.to('#bubble-dust', 10, {
      bezier: [{x: 0, y: 0}, {x: -12, y: 5}, {x: -8, y: -7}, {x: 0, y: 0}, {x: 16, y: 4}, {x: 3, y: -10}, {x: 0, y: 0}],
      ease: Linear.easeNone,
      repeat: -1
    });

    bubbleTempTween.pause();
    bubbleHumidityTween.pause();
    bubbleCO2Tween.pause();
    bubbleChemicalsTween.pause();
    bubbleDustTween.pause();

    new ScrollMagic.Scene({
      triggerElement: howItWorksSectionRef,
      triggerHook: 'onEnter',
      duration: '200%',
      offset: 0
    })
      .on('enter', () => {
        bubbleTempTween.paused(false);
        bubbleHumidityTween.paused(false);
        bubbleCO2Tween.paused(false);
        bubbleChemicalsTween.paused(false);
        bubbleDustTween.paused(false);

        howItWorksSectionStore.setParticleCount(this.getParticleCount());
      })
      .on('leave', () => {
        bubbleTempTween.paused(true);
        bubbleHumidityTween.paused(true);
        bubbleCO2Tween.paused(true);
        bubbleChemicalsTween.paused(true);
        bubbleDustTween.paused(true);

        howItWorksSectionStore.setParticleCount(0);
      })
      .addTo(howItWorksController);
  };

  initializeSwiper = () => {
    this.factorsSwiper = new Swiper('#factors-swiper', {
      pagination: '.swiper-pagination',
      loop: true,
      paginationType: 'bullets',
      paginationClickable: true,
      paginationBulletRender: (index, className) => {
        return `<span class="${className}"><div class="svg-icon"></div></span>`;
      }
    });
  };

  handleSwiperShow = () => {
    const {factorsSwiper} = this;
    const widthCheck = window.innerWidth;

    if (widthCheck < 980) {
      $('#factors-swiper').fadeIn('normal', () => {
        factorsSwiper.update(true);
      })
    }
  };

  handleSwiperHide = () => {
    $('#factors-swiper').fadeOut();
  };

  componentWillMount() {
    howItWorksSectionStore.setParticleCount(this.getParticleCount());
  }

  componentDidMount() {
    this.handleSceneAnimation();
    this.initializeSwiper();
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  render() {
    const {handleSwiperShow, handleSwiperHide} = this;

    return (
      <section className={cx('how-it-works')} ref={ref => this.howItWorksSectionRef = ref}>
        <ParticleCanvas
          particleCount={howItWorksSectionStore.particleCount}
        />
        <HowItWorksSceneBackdrop />
        <HowItWorksSceneForeground
          swiperShow={handleSwiperShow}
          swiperHide={handleSwiperHide}
        />
      </section>
    );
  }
}

export default HowItWorksSection;


// WEBPACK FOOTER //
// ./src/app/components/organisms/HowItWorksSection/HowItWorksSection.js